import { AxiosResponse } from 'axios';

import { RecordingResponse } from 'store/recordings/reducer.types';

function isRecordingsResponse(
    response: any,
): response is AxiosResponse<RecordingResponse> {
    return !!response?.data?.recordingSet;
}

export default isRecordingsResponse;
